// src/i18n/index.ts
import { reactive, computed } from 'vue'
import { es } from './es'
import { en } from './en'
import { br } from './br'
import { fr } from './fr'

export const translations = { es, en, br, fr } as const

export type LocaleKey = keyof typeof translations

export const i18nState = reactive({
  locale: 'es' as LocaleKey,
})

/** Objeto de traducción reactivo. Cambia automáticamente al cambiar i18nState.locale */
export const t = computed(() => translations[i18nState.locale])

export function setLocale(locale: LocaleKey) {
  i18nState.locale = locale
  localStorage.setItem('sgi-locale', locale)
}

export function initLocale() {
  const saved = localStorage.getItem('sgi-locale') as LocaleKey | null
  if (saved && translations[saved]) {
    i18nState.locale = saved
  }
}

export const availableLocales = [
  { key: 'es' as LocaleKey, label: 'Español', flag: '🇦🇷' },
  { key: 'en' as LocaleKey, label: 'English', flag: '🇺🇸' },
  { key: 'br' as LocaleKey, label: 'Português', flag: '🇧🇷' },
  { key: 'fr' as LocaleKey, label: 'Français', flag: '🇫🇷' },
] as const